<div class="mb-6" *ngIf="auctionId">
    <app-header [id]="auctionId"></app-header>
</div>

<div class="lg:pt-2 bg-gray-20 lg:border-b border-gray-300">
    <div class=" container mx-auto lg:px-16 lg:mb-20 px-3 space-y-4 ">

        <div class="flex flex-col lg:flex-row gap-4">

            <div class="w-full  space-y-4">
                <h2 class="text-2xl font-bold font-mulish mb-6">Thank you!</h2>
                <p class="font-mulish text-base">The following information has been submitted for consideration.
                    Thank you for your donation to our auction. The auction committee will contact you via email
                    afterthe item has been reviewed.
                </p>
                <p>
                    If you need to contact us regarding the item you have submitted, please contact us by email at
                    {{item?.contactEmail}}.
                </p>
            </div>

        </div>

        <div class="flex flex-col md:flex-row gap-8 items-stretch pt-6" *ngIf="item">



            <div class="md:w-1/2 flex flex-col items-center max-w-[500px] mx-auto md:mx-0 ">
                <div class="relative w-full h-[350px] flex justify-center">
                    <img [src]="selectedImage" [alt]="item.name" class="w-full h-full object-contain rounded-lg shadow">
                </div>
                <div class="flex gap-6 mt-2 w-full items-center" [ngClass]="{
    'justify-center': (formattedImages?.length || 0) <= 3,
       'justify-between': (formattedImages?.length || 0) >= 4
  }">
                    <img *ngFor="let img of formattedImages" [src]="img" (click)="selectedImage = img" [alt]="item.name"
                        class="w-16 h-16 object-cover cursor-pointer border rounded-md hover:ring-2 hover:ring-blue-400 transition " />
                </div>
            </div>

            <div class="md:w-1/2 flex flex-col  space-y-8">
                <span class="font-mulish font-bold text-3xl">
                    {{ item.name }}
                </span>
                <div class="grid grid-cols-[auto_1fr] gap-x-20 ">
                    <p class="text-lg font-semibold font-mulish">Quantity:</p>
                    <p class="text-base font-mulish mb-3">{{ item.quantity}}</p>

                    <p class="text-lg font-semibold font-mulish">Value:</p>
                    <p class="text-base font-mulish mb-3">${{ item.value }} {{currency()}}</p>

                    <p class="text-lg font-semibold font-mulish">Description:</p>
                    <p class="text-base font-mulish mb-3 items-center"
                        [innerHTML]="item.description | sanitizeHtmlText"></p>

                    <ng-container *ngIf="item.specialNote">
                        <p class="text-lg font-semibold font-mulish">Of Special Note:</p>
                        <p class="text-base font-mulish mb-3 items-center"
                            [innerHTML]="item.specialNote! | sanitizeHtmlText"></p>
                    </ng-container>

                    <p class="text-lg font-semibold font-mulish">Donated by:</p>
                    <p class="text-base font-mulish mb-3 items-center">{{item.donatedBy}}</p>
                </div>
            </div>
        </div>
        <div class="pt-10 flex gap-2 ">

            <button pButton [routerLink]="['/auction', auctionId]"
               class="  h-[35px] lg:h-[40px] !bg-white !border !border-[var(--p-info-500)] !text-[var(--p-info-500)] font-medium text-base flex-[1] !rounded-full flex justify-end items-center" [rounded]="true">
               <!-- <i class="hidden lg:inline pi pi-angle-double-left  text-xs left-3">
                </i> -->
                <span class=" font-mulish font-semibold  text-center w-full text-base tracking-wide">
                    Go to Event Page
                </span>
            </button>

            <button pButton type="button" [routerLink]="['/items-donation', auctionId]"                                
                                 class=" h-[35px] lg:h-[40px] p-button-info rounded-m w-full relative flex-[1] flex items-center justify-center gap-2 tracking-wide" [rounded]="true">
                <!-- <i class=" hidden lg:inline pi pi-angle-double-left text-xl"></i> -->
                <span class="font-semibold  text-center w-full text-base[13px] font-mulish ">
                    Donate Another Item
                </span>
            </button>
        </div>
    </div>
</div>

<div class="mt-[30px]">
    <app-footer></app-footer>
</div>